import { atom } from 'jotai';
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  clientId: window.AUTH_CLIENT_ID,
  realm: window.AUTH_REALM,
  url: window.AUTH_URL,
});

const keycloakInstance = atom(keycloak);
const keycloakTimeout = atom(0);

export const auth = {
  keycloakInstance,
  keycloakTimeout,
};
